import { z } from 'zod';

// Smart Sort response schema
export const smartSortResponseSchema = z.object({
  ordered_ids: z.array(z.string()),
  scores: z.record(z.string(), z.number().min(0).max(1)).optional(),
  scoring_notes: z.string().optional(),
  request_id: z.string(),
  version: z.string()
});

export const smartSortErrorSchema = z.object({
  error: z.object({
    code: z.enum(['TIMEOUT', 'SCHEMA_ERROR', 'RATE_LIMIT', 'MODEL_ERROR', 'INPUT_INVALID']),
    message: z.string(),
    request_id: z.string()
  })
});

export type SmartSortResponse = z.infer<typeof smartSortResponseSchema>;
export type SmartSortError = z.infer<typeof smartSortErrorSchema>;

// Validate response and return parsed data or null
export function validateSmartSortResponse(data: unknown): SmartSortResponse | null {
  try {
    return smartSortResponseSchema.parse(data);
  } catch (error) {
    console.warn('Invalid smart sort response schema:', error);
    return null;
  }
}

export function validateSmartSortError(data: unknown): SmartSortError | null {
  try {
    return smartSortErrorSchema.parse(data);
  } catch (error) {
    return null;
  }
}